import { WidgetExternalApplicationType } from '../../../../types/widget';
import ExternalApplicationItem from '../components/ExternalApplicationItem';
import ExternalApplicationForm from '../configuration/ExternalApplicationForm';
import { ExternalApplicationDetails, ExternalApplicationType } from '../types/externalApplication';
import { FormFieldEnum, SpecificFieldsType } from '../types/form';

type MegSSOSpecificType = {
	url: string;
};

type ExternalApplicationFormProps = {
	application: WidgetExternalApplicationType;
	isNew: boolean;
	onSubmit: (application: WidgetExternalApplicationType) => void;
	onRemove: (application: WidgetExternalApplicationType) => void;
};

export const MegSSOForm = ({ application, isNew, onSubmit, onRemove }: ExternalApplicationFormProps) => {
	const { key, specific } = application;
	const jsonSpecific = specific ? (JSON.parse(specific) as MegSSOSpecificType) : undefined;
	const { url } = jsonSpecific ?? {};

	const specificFields: SpecificFieldsType[] = [
		{
			key,
			name: 'url',
			type: FormFieldEnum.TEXTFIELD,
			value: url,
			description: 'URL du SSO Meg',
			label: 'URL SSO',
			rules: {
				required: true,
			},
		},
	];

	return (
		<ExternalApplicationForm
			application={application}
			isNew={isNew}
			specificFields={specificFields}
			onSubmit={onSubmit}
			onRemove={onRemove}
		/>
	);
};

const MegSSO = ({ name }: ExternalApplicationType) => (
	<ExternalApplicationItem name={name} imageSrc="/widgets/images/meg-rvb-logo.svg" />
);

export const getDetails = ({
	name,
	specific,
}: Pick<ExternalApplicationType, 'name' | 'specific'>): ExternalApplicationDetails => {
	const jsonSpecific = specific ? (JSON.parse(specific) as MegSSOSpecificType) : undefined;
	const { url } = jsonSpecific ?? {};

	if (!url) {
		throw new Error('The Meg SSO client is missing.');
	}

	return {
		component: <MegSSO name={name} />,
		name,
		url,
	};
};
